import React from 'react';
import PropTypes from 'prop-types';

import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ color, bgcolor }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: bgcolor || '#616161',
    color: color || '#fff',
    fontSize: '12px',
    fontWeight: 500,
    borderRadius: '4px',
    padding: '8px 12px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
    maxWidth: '300px',
  },
  [`& .MuiTooltip-arrow`]: {
    color: bgcolor || '#616161',
  },
}));

const CommonTooltip = ({
  children,
  title,
  placement = 'top',
  arrow = true,
  bgcolor = '#616161',
  color = '#fff',
  disabled = false,
  enterDelay = 500,
  leaveDelay = 200,
  ...props
}) => (
  <StyledTooltip
    title={title}
    placement={placement}
    arrow={arrow}
    bgcolor={bgcolor}
    color={color}
    enterDelay={enterDelay}
    leaveDelay={leaveDelay}
    disableHoverListener={disabled}
    {...props}
  >
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>{children}</span>
  </StyledTooltip>
);

CommonTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  placement: PropTypes.oneOf([
    'bottom-end',
    'bottom-start',
    'bottom',
    'left-end',
    'left-start',
    'left',
    'right-end',
    'right-start',
    'right',
    'top-end',
    'top-start',
    'top',
  ]),
  arrow: PropTypes.bool,
  bgcolor: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  enterDelay: PropTypes.number,
  leaveDelay: PropTypes.number,
};

export default CommonTooltip;
